import React from "react";

export default function Wave({ direction = "up" }) {
  const directionValue =
    ["up", "down"].indexOf(direction.toLowerCase()) > -1 ? direction : "up";

  return <div className={`row wave-${directionValue}`} />;
}
